export const SectionHeading = ({ label, title, desc, light = false }) => {
  return (
    <div className="max-w-2xl">
      <div className="flex items-center gap-3">
        <span className="h-px w-10 bg-red-600" />
        <span className="text-xs font-bold tracking-[0.3em] uppercase text-red-500">
          {label}
        </span>
      </div>
      <h2
        className={`mt-4 font-heading uppercase tracking-tight text-5xl md:text-6xl ${
          light ? "text-white" : "text-white"
        }`}
      >
        {title}
      </h2>
      {desc && (
        <p className="mt-4 text-base md:text-lg text-zinc-400 leading-relaxed">
          {desc}
        </p>
      )}
    </div>
  );
};
